'use strict';

global.jQuery = $;
global.$ = $;
import $ from 'jquery';
window.$ = window.jQuery = $;
import { Fancybox } from "@fancyapps/ui";
/**
 *  Load modules
 */
require('./modules/custom-select');
import header from './modules/header.js';
import sliders from './modules/sliders.js';
import functions from './modules/functions.js';
import albumModal from './modules/album-modal.js';
import estateTable from './modules/estate-table.js';
import showIn from './modules/show-in.js';
import '../scss/app.scss';
$(document).ready(function () {
  header();
  sliders();
  functions();
  albumModal();
  estateTable();
  showIn();
  Fancybox.bind("[data-fancybox]", {});
});

//counters
var $findme = $('.counter__items');
var exec = false;
function Scrolled() {
  $findme.each(function () {
    var $section = $(this),
      findmeOffset = $section.offset(),
      findmeTop = findmeOffset.top,
      findmeBottom = $section.height() + findmeTop,
      scrollTop = $(document).scrollTop(),
      visibleBottom = window.innerHeight,
      prevVisible = $section.prop('_visible'),
      visible = true;
    if (findmeTop > scrollTop + visibleBottom || findmeBottom < scrollTop) {
      visible = false;
    }
    if (!prevVisible && visible) {
      if (!exec) {
        $('.counter-item span').each(function () {
          $(this).prop('Counter', 0).animate({
            Counter: $(this).text()
          }, {
            duration: 1000,
            step: function step(now) {
              $(this).text(Math.ceil(now));
              exec = true;
            }
          });
        });
      }
    }
    $section.prop('_visible', visible);
  });
}
$(document).ready(function () {
  Scrolled();
  $(window).scroll(function () {
    Scrolled();
  });
});